import CustomValidator from '@mixins/validators/CustomValidator'
import PubSub from '@helper/PubSub'
import zipCitiesQuery from '@queries/zipCities.gql'

export default {
  mixins: [CustomValidator],
  methods: {
    validateZipCode(zipCode) {
      if (!zipCode) {
        return new Promise((resolve) => {
          resolve(false)
        })
      }

      PubSub.publish('show-loader')

      return this.$apollo.query({
        query: zipCitiesQuery,
        variables: {
          zips: [zipCode],
        },
      }).then((response) => {
        PubSub.publish('hide-loader')
        return response.data.zipCities.length > 0
      })
    },
  },

  created() {
    this.addCustomValidator('validate_zipcode', {
      validate: (value) => new Promise((resolve) => {
        this.validateZipCode(value)
          .then((valid) => resolve({ valid }))
          .catch((_) => resolve({ valid: false }))
      }),
    })
  },
}
